import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { Container, Modal, Typography } from '@material-ui/core';
import ActionButton from '../../../components/ActionButton';
import SelezioneGruppo from './SelezioneGruppo';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    gap: theme.spacing(4),
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(4),
    boxShadow: theme.shadows[6],
    borderRadius: '6px',
    overflowY: 'auto',
    maxWidth: '560px',
  },

  selectWrapper: {
    width: '85%',
  },
});

class ModalSelezioneGruppo extends Component {
  render() {
    const { classes, gruppi, gruppoId, origin } = this.props;
    const gruppiFiltered = gruppi.filter((item) => item.id !== -1);
    const gruppoIdNormalized =
      gruppoId != null && gruppoId !== -1 ? gruppoId : null;
    const hasSelection = gruppoIdNormalized != null;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onCancel}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          {origin === 'Modello' ? (
            <Typography variant="h6">
              Scegli il gruppo di appartenenza del nuovo modello
            </Typography>
          ) : (
            <Typography variant="h6">
              Scegli il gruppo di appartenenza del nuovo manuale
            </Typography>
          )}
          <div className={classes.selectWrapper}>
            <SelezioneGruppo
              layout="modal"
              gruppoId={gruppoIdNormalized}
              gruppi={gruppiFiltered}
              disabled={false}
              description=""
              onGruppoSelected={this.props.onGruppoSelected}
            />
          </div>
          <Container style={{ paddingTop: '20px', textAlign: 'center' }}>
            <ActionButton
              label="Annulla"
              disabled={false}
              onClick={this.props.onCancel}
              grayVersion={false}
              secondaryButton
            />
            <ActionButton
              label={origin === 'Modello' ? 'Crea modello' : 'Crea manuale'}
              disabled={!hasSelection}
              onClick={() => {
                this.props.onCreaButtonClicked(origin);
              }}
              grayVersion={false}
            />
          </Container>
        </div>
      </Modal>
    );
  }
}

ModalSelezioneGruppo.propTypes = {
  classes: PropTypes.object.isRequired,
  gruppoId: PropTypes.number,
  gruppi: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  origin: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onGruppoSelected: PropTypes.func.isRequired,
  onCreaButtonClicked: PropTypes.func.isRequired,
};

export default withStyles(styles)(ModalSelezioneGruppo);
